module.exports = __webpack_public_path__ + "static/media/page10_mum_kids.c1dfc1d2.png";